import React, { useEffect, useCallback } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { Form, Input, Row, Col, Typography, Select } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { useProfileInfoContext } from 'contexts/profileInfo';
import TextArea from 'antd/es/input/TextArea';
import { mobileRegexNew, mobileRegexhk } from 'utils/regex';
// import { Spinner } from 'components';
import { MobileNumberHasAreaPrefix } from 'components';
// import { disabledDate } from 'utils';
// import { useProfileInfoContext } from 'contexts/profileInfo';
import { usePolicyDropDown, useLifeUserProfile } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';
import { isLocaleEnglish } from 'utils';
import { Spinner } from 'components';
// import styled from 'styled-components';

export const Claimform = (props: { policyNo?: string }) => {
  const { t, i18n } = useTranslation();
  const [claimType, setClaimType] = useState<boolean>(false);
  const [DethType, setDethType] = useState<boolean>(false);
  const [OtherType, setOtherType] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openList, setOpenList] = useState(false);
  const { state: data } = useProfileInfoContext();
  const { keycloak } = useKeycloakReady();
  const { shouldFetch: profileshouldFetch, data: profileInfoData } = useLifeUserProfile(
    'useLifeUserProfile',
    keycloak.token || '',
  );
  const form = useFormInstance();
  useEffect(() => {
    profileshouldFetch(true);
    if (profileInfoData) {
      form.setFieldsValue({
        name: `${profileInfoData.firstName} ${profileInfoData.lastName}`,
      });
    }
  }, [data, form, profileshouldFetch, profileInfoData]);
  // const phone = Form.useWatch('phone', form);
  // const mail = Form.useWatch('mail', form);
  // const [showCard, setShowCard] = useState<boolean>(false);
  // const { state: data, isLoading } = useProfileInfoContext();

  // useEffect(() => {
  //   if (data) {
  //     form.setFieldsValue({
  //       name: `${data.firstName} ${data.lastName}`,
  //       mail: data.email,
  //       phone: data.mobile,
  //     });
  //   }
  // }, [data, form]);
  const onChange2 = (e: Array<string>) => {
    if (policyTypesObject.length == 1 && e.length == 1) {
      setOpenList(false);
    } else {
      setOpenList(true);
    }
  };

  const onChange = (e: string) => {
    console.log('11111', e);
    if (e === 'Waiver of Premium' || e === '保費豁免' || e === 'Critical Illness' || e === '危疾') {
      setClaimType(true);
      setDethType(false);
      setOtherType(false);
    } else if (e === 'Death' || e === '身故') {
      setClaimType(false);
      setDethType(true);
      setOtherType(false);
    } else if (e === 'Others' || e === '其他') {
      setClaimType(false);
      setDethType(false);
      setOtherType(true);
    } else {
      setClaimType(false);
      setDethType(false);
      setOtherType(false);
    }
  };
  const handleChange = useCallback(
    (value: string) => {
      form.setFieldsValue({
        countryCode: value,
      });
      // if (value) {
      //   setShowCard(true);
      // } else {
      //   setShowCard(false);
      // }
    },
    [form],
  );
  useEffect(() => {
    handleChange('+852');
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [handleChange]);
  const { shouldFetch: shouldFecthDrop, data: dropData } = usePolicyDropDown('usePolicyDropDown', keycloak.token || '');
  const policyTypesObject: { label: string; label2: string; value: string }[] = [];
  dropData?.map((item) => {
    policyTypesObject.push({
      label: i18n.language == 'en' ? item.productName : item.productNameTC,
      label2: `${t('life.enquiry.policyNo')}${item.policyNumber}`,
      value: item.policyNumber,
    });
  });
  const claimTypesObject = [
    { label: 'Critical Illness', value: 'Critical Illness' },
    { label: 'Death', value: 'Death' },
    { label: 'Waiver of Premium', value: 'Waiver of Premium' },
    { label: 'Others', value: 'Others' },
  ];
  const zhClaimTypesObject = [
    { label: '危疾', value: '危疾' },
    { label: '身故', value: '身故' },
    { label: '保費豁免', value: '保費豁免' },
    { label: '其他', value: '其他' },
  ];
  const causedBy = [
    { label: 'Illiness', value: 'Illiness' },
    { label: 'Accident', value: 'Accident' },
    { label: 'Others', value: 'Others' },
  ];
  const zhCausedBy = [
    { label: '疾病', value: '疾病' },
    { label: '意外', value: '意外' },
    { label: '其他', value: '其他' },
  ];
  const timeTypesObject = [
    { label: `${t('life.enquiry.anytime')}`, value: `${t('life.enquiry.anytime')}` },
    { label: `${t('life.enquiry.morning')}`, value: `${t('life.enquiry.morning')}` },
    { label: `${t('life.enquiry.afternoon')}`, value: `${t('life.enquiry.afternoon')}` },
  ];

  useEffect(() => {
    // setRequiresMailOrPhone(!mail);
    // if (form.isFieldTouched('phone') || form.isFieldTouched('mail')) {
    //   form.validateFields(['phone', 'mail']);
    // }
    shouldFecthDrop(true);
    setIsLoading(true);
  }, [shouldFecthDrop, setIsLoading]);
  useEffect(() => {
    if (!dropData) return;
    setIsLoading(false);
  }, [dropData, setIsLoading]);
  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
      <Col xs={24} md={24}>
        <Typography.Text className="headertittle">{t('life.MakeClaim.informationbelow')}</Typography.Text>
      </Col>
      <Col xs={24} md={24} style={{ marginBottom: '10px' }}>
        <Typography.Text className="headertext">{t('life.MakeClaim.mandatoryMsg')}</Typography.Text>
      </Col>
      {isLoading && <Spinner />}
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          rules={[{ required: true, message: t('life.MakeClaim.Selectyourpoliciesrules') }]}
          label={
            <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              {t('life.MakeClaim.Selectyourpolicies')}
            </span>
          }
          name="policyNumber"
          initialValue={props.policyNo ? [props.policyNo] : []}
        >
          <Select
            mode="multiple"
            popupClassName="slectop"
            placeholder={t('life.enquiry.policyPlaceholder')}
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
            }}
            open={openList}
            onChange={onChange2}
            onFocus={() => setOpenList(true)}
            onBlur={() => setOpenList(false)}
          >
            {policyTypesObject &&
              policyTypesObject.map((item) => (
                <Select.Option key={item.value} value={item.value} label2={item.label2} title={item.label2}>
                  <div style={{ display: 'grid' }}>
                    <span>{item.label}</span>
                    <span>{item.label2}</span>
                  </div>
                </Select.Option>
              ))}
          </Select>
        </BoldLabelFormItem>
      </Col>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          rules={[{ required: true, message: t('life.MakeClaim.selectclaimtyperules') }]}
          required
          label={
            <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              {t('life.MakeClaim.Claimtype')}
            </span>
          }
          name="claimType"
        >
          <Select
            popupClassName="slectop"
            placeholder={t('life.MakeClaim.selectclaimtype')}
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
            }}
            onChange={onChange}
          >
            {(isLocaleEnglish(i18n.language) ? claimTypesObject : zhClaimTypesObject).map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
        </BoldLabelFormItem>
      </Col>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          rules={[{ required: true, message: t('life.MakeClaim.selectcausedrules') }]}
          required
          label={
            <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              {t('life.MakeClaim.Causedby')}
            </span>
          }
          name="causedBy"
        >
          <Select
            popupClassName="slectop"
            placeholder={t('life.MakeClaim.selectcaused')}
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              marginBottom: '10px',
              padding: '4px 0',
            }}
          >
            {(isLocaleEnglish(i18n.language) ? causedBy : zhCausedBy).map((item) => (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            ))}
          </Select>
        </BoldLabelFormItem>
      </Col>

      <Col xs={24} md={24}>
        <BoldLabelFormItem
          rules={[
            { required: true, message: t('life.MakeClaim.enterlabelrules') },
            // {
            //   min: 10,
            //   message: t('life.MakeClaim.enterlabelrules'),
            // },
          ]}
          required
          label={
            <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              {DethType ? `${t('life.MakeClaim.SymptomsAccidentdetails2')}` : `${t('life.MakeClaim.enterlabel')}`}
            </span>
          }
          name="Entermessage"
        >
          <TextArea
            showCount
            maxLength={500}
            placeholder={t(`life.MakeClaim.Entermessage`)}
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              fontWeight: 'normal',
              height: '220px',
              marginBottom: '10px',
            }}
          />
        </BoldLabelFormItem>
      </Col>

      {claimType && (
        <Col xs={24} md={24}>
          <BoldLabelFormItem
            label={
              <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                {t('life.MakeClaim.accident')}*
              </span>
            }
            name="accidentdob"
            rules={[{ required: claimType, message: t('life.MakeClaim.accidentrules') }]}
          >
            {/* <DatePicker
              disabledDate={disabledDate}
              placeholder={t('life.MakeClaim.enterDate')}
              format="DD/MM/YYYY"
              style={{
                border: 'none',
                borderBottom: '1px solid #E5E5E5',
                color: 'white',
                backgroundColor: 'transparent',
                width: '100%',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                padding: '4px 0',
              }}
            /> */}
            <Input
              size="middle"
              placeholder={t('life.MakeClaim.enterDate')}
              maxLength={30}
              style={{
                border: 'none',
                borderBottom: '1px solid #CCCCCC',
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                padding: '4px 0',
              }}
            />
          </BoldLabelFormItem>
        </Col>
      )}
      {claimType && (
        <Col xs={24} md={24}>
          <BoldLabelFormItem
            rules={[
              { required: claimType, message: t('life.MakeClaim.enterDiagnosisrules') },
              // {
              //   min: 10,
              //   message: t('life.MakeClaim.enterDiagnosisrules'),
              // },
            ]}
            required
            label={
              <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                {t('life.MakeClaim.Diagnosis')}
              </span>
            }
            name="Diagnosis"
          >
            <TextArea
              showCount
              maxLength={200}
              placeholder={t(`life.MakeClaim.enterDiagnosis`)}
              style={{
                fontSize: '20px',
                fontFamily: 'Roboto400',
                fontWeight: 'normal',
                height: '220px',
                marginBottom: '10px',
              }}
            />
          </BoldLabelFormItem>
        </Col>
      )}
      {DethType && (
        <Col xs={24} md={24}>
          <BoldLabelFormItem
            label={
              <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                {t('life.MakeClaim.Dateofdeath')}*
              </span>
            }
            name="deathdob"
            rules={[{ required: DethType, message: t('life.MakeClaim.Dateofdeathrules') }]}
          >
            {/* <DatePicker
              disabledDate={disabledDate}
              placeholder={t('life.MakeClaim.enterDate')}
              format="DD/MM/YYYY"
              style={{
                border: 'none',
                borderBottom: '1px solid #E5E5E5',
                color: 'white',
                backgroundColor: 'transparent',
                width: '100%',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                padding: '4px 0',
              }}
            /> */}
            <Input
              size="middle"
              placeholder={t('life.MakeClaim.enterDate')}
              maxLength={30}
              style={{
                border: 'none',
                borderBottom: '1px solid #CCCCCC',
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                padding: '4px 0',
              }}
            />
          </BoldLabelFormItem>
        </Col>
      )}
      {(DethType || OtherType) && (
        <Col xs={24} md={24}>
          <BoldLabelFormItem
            rules={[
              { required: DethType || OtherType, message: t('life.MakeClaim.enterdeathDetailsrules') },
              // {
              //   min: 10,
              //   message: t('life.MakeClaim.enterdeathDetailsrules'),
              // },
            ]}
            required
            label={
              <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                {t('life.MakeClaim.Details')}
              </span>
            }
            name="detailes"
          >
            <TextArea
              showCount
              maxLength={200}
              placeholder={t(`life.MakeClaim.enterdeathDetails`)}
              style={{
                fontSize: '20px',
                fontFamily: 'Roboto400',
                fontWeight: 'normal',
                height: '220px',
                marginBottom: '10px',
              }}
            />
          </BoldLabelFormItem>
        </Col>
      )}
      <Col xs={24} md={24}>
        <Form.Item
          label={
            <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              {t('life.MakeClaim.phoneLabel')}
            </span>
          }
          className="mobile"
          style={{ marginBottom: 12 }}
        >
          <div className="countryCodestyle">
            <Form.Item name="countryCode">
              {/* <MobileNumberPrefix defaultValue="+852" handleChange={handleChange} /> */}
              <MobileNumberHasAreaPrefix defaultValue="+852" handleChange={handleChange} />
            </Form.Item>
          </div>
          <div className="phonestyle">
            <Form.Item
              rules={[
                { required: true, message: t('life.MakeClaim.phoneLabelrules') },
                () => ({
                  validator(_, value) {
                    if (
                      !value ||
                      (form.getFieldValue('countryCode').trim() == '+852'
                        ? mobileRegexhk.test(value)
                        : mobileRegexNew.test(value))
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t('life.MakeClaim.phoneLabelrules')));
                  },
                }),
              ]}
              required
              name="phone"
            >
              <Input
                size="middle"
                // onChange={onChange}
                placeholder={t('life.MakeClaim.phonePlaceholder')}
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  height: '40px',
                  borderRadius: 0,
                }}
              />
            </Form.Item>
          </div>
        </Form.Item>
      </Col>
      <Col xs={24} md={24}>
        <BoldLabelFormItem
          rules={[{ required: true, message: t('life.MakeClaim.timeSlotrules') }]}
          required
          label={
            <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
              {t('life.MakeClaim.timeLabel')}
            </span>
          }
          name="contactTime"
        >
          <Select
            popupClassName="slectop"
            placeholder={t('life.MakeClaim.timeSlot')}
            style={{
              fontSize: '20px',
              fontFamily: 'Roboto400',
              fontWeight: 'normal',
              marginBottom: '10px',
              padding: '4px 0',
            }}
          >
            {timeTypesObject &&
              timeTypesObject.map((item) => (
                <Select.Option key={item.label} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
          </Select>
        </BoldLabelFormItem>
      </Col>
    </Row>
  );
};
